export default __webpack_public_path__ + "static/media/signup.5500a5be.jpg";